// extracted by mini-css-extract-plugin
module.exports = {"CellList":"src-components-Main-Infos-WorldModal-CellList-CellList--2tJWP","cellListItem":"src-components-Main-Infos-WorldModal-CellList-CellList--3RQIK"};